export default __webpack_public_path__ + "assets/ico_arrival-a8a93b8f.svg";